import { Injectable, inject } from '@angular/core';
import { GoogleTrackingService } from '../google-tracking.service';

@Injectable({
    providedIn: 'root',
})
export class PrintTrackingService {
    private readonly _googleTrackingService = inject(GoogleTrackingService);

    public trackPrintBusinessCard(): void {
        this._googleTrackingService.track({
            event: 'itemClick',
            itemClick: 'Print - Businesscard',
        });
    }

    public trackPrintSearchResults(): void {
        this._googleTrackingService.track({
            event: 'itemClick',
            itemClick: 'Print - FHS',
        });
    }
}
